/*
  Custom Combo Builder - Extended from native Jhango collection-bundle.js
*/

class CustomComboBuilder extends HTMLElement {
  constructor() {
    super();

    this.comboHandle = this.dataset.combo;
    
    try {
        const tiersAttr = this.getAttribute("data-tiers");
        this.tiers = tiersAttr ? JSON.parse(tiersAttr) : [];
    } catch(e) {
        this.tiers = [];
    }
    
    this.storageKey = `gonourishy_combo_${this.comboHandle}_bundle`;
    this.bundleContents = JSON.parse(localStorage.getItem(this.storageKey)) || [];
    this.bundleContents.forEach(item => {
        if (!item.uid) item.uid = Date.now() + Math.random().toString(36).substring(2, 9);
        if (this.comboHandle === 'complete-honest-kitchen-box' && (item.category === 'besan' || item.category === 'wheat')) item.auto_added = true;
        if (this.comboHandle === 'everyday-roti-ritual-box' && item.category === 'besan') item.auto_added = true;
    });
    this.card = this.querySelector("#collection-bundle-card");

    this.buildBundle();
    this.calcPrices();
    this.handleCartStickyPosition();
    this.animateBtnBundleCheckout();
    this.initStickyMobileCard();
    
    // Auto-add items if needed on short delay to ensure DOM is ready
    setTimeout(() => {
        this.autoAddRequiredItems();
    }, 500);

    this.querySelectorAll(".combo-checkbox").forEach((checkbox) => {
      checkbox.addEventListener("change", (e) => {
        this.toggleBundleItem(checkbox);
      });
    });

    this.querySelectorAll('.product-card select[name="id"]').forEach(
      (select) => {
        select.addEventListener("change", () =>
          this.onChangeProductCardVariant(select)
        );
      }
    );

    this.querySelectorAll(".collection-bundle-card-list .btn-close").forEach(
      (btn) => {
        btn.addEventListener("click", (e) => {
          this.removeFromBundle(btn);
        });
      }
    );

    this.querySelectorAll(".btn-bundle-checkout").forEach((btn) => {
      btn.addEventListener("click", () => this.handleCheckout(btn));
    });
  }
  
  autoAddRequiredItems() {
    if (this.comboHandle === 'everyday-roti-ritual-box') {
      const cards = this.querySelectorAll(".product-card");
      cards.forEach((card) => {
        const select = card.querySelector("select");
        const checkbox = card.querySelector(".combo-checkbox");
        if(select && checkbox && !checkbox.checked) {
            const selectedOption = select.options[select.selectedIndex];
            if (selectedOption && selectedOption.dataset.comboCategory && selectedOption.dataset.comboCategory.toLowerCase() === 'besan') {
              const exists = this.bundleContents.find(item => item.product_id === Number(selectedOption.dataset.productId));
              if (!exists) {
                checkbox.checked = true;
                this.toggleBundleItem(checkbox, true);
              }
            }
        }
      });
    } else if (this.comboHandle === 'complete-honest-kitchen-box') {
        const cards = this.querySelectorAll(".product-card");
        cards.forEach((card) => {
          const select = card.querySelector("select");
          const checkbox = card.querySelector(".combo-checkbox");
          if(select && checkbox && !checkbox.checked) {
              const selectedOption = select.options[select.selectedIndex];
              if (selectedOption && selectedOption.dataset.comboCategory) {
                  const cat = selectedOption.dataset.comboCategory.toLowerCase();
                  if (cat === 'besan' || cat === 'wheat') {
                      const exists = this.bundleContents.find(item => item.product_id === Number(selectedOption.dataset.productId));
                      if (!exists) {
                          checkbox.checked = true;
                          this.toggleBundleItem(checkbox, true);
                      }
                  }
              }
          }
        });
    }
  }

  toggleBundleItem(checkbox, silent = false, isAutoAdded = false) {
    const card = checkbox.closest(".product-card");
    const select = card.querySelector("select");
    const selectedOption = select.options[select.selectedIndex];
    const productId = Number(checkbox.dataset.productId);
    
    if (checkbox.checked) {
      // Check custom rules before adding
      const category = selectedOption.dataset.comboCategory ? selectedOption.dataset.comboCategory.toLowerCase() : '';
      const title = selectedOption.dataset.productTitle ? selectedOption.dataset.productTitle.toLowerCase() : '';
      if (!this.canAddItemCategory(category, title)) {
          checkbox.checked = false;
          if(!silent) alert("You cannot add more items of this type based on the combo rules.");
          return;
      }

      this.bundleContents.push({
        uid: Date.now() + Math.random().toString(36).substring(2, 9),
        product_id: productId,
        product_title: selectedOption.dataset.productTitle,
        variant_id: Number(selectedOption.dataset.variantId),
        variant_img: selectedOption.dataset.variantImg,
        variant_price: Number(selectedOption.dataset.variantPrice),
        variant_compare_at_price: Number(selectedOption.dataset.variantCompareAtPrice || selectedOption.dataset.variantPrice),
        category: category,
        auto_added: isAutoAdded
      });
    } else {
      this.bundleContents = this.bundleContents.filter(item => item.product_id !== productId);
    }

    this.sortBundle();

    localStorage.setItem(this.storageKey, JSON.stringify(this.bundleContents));

    this.buildBundle();
    this.calcPrices();
  }

  canAddItemCategory(category, title = '') {
      if (this.comboHandle === 'build-your-honest-food-discovery-box') {
          const pastas = this.bundleContents.filter(i => i.category === 'pasta').length;
          const millets = this.bundleContents.filter(i => i.category === 'millet').length;
          const wheats = this.bundleContents.filter(i => i.category === 'wheat').length;
          const khapli = this.bundleContents.filter(i => i.category === 'khapli').length;
          
          if (category === 'pasta' && pastas >= 4) return false;
          if (category === 'millet' && millets >= 1) return false;
          if (category === 'wheat' && wheats >= 1) return false;
          if (category === 'khapli' && khapli >= 1) return false;
      }
      else if (this.comboHandle === 'everyday-roti-ritual-box') {
          const wheats = this.bundleContents.filter(i => i.category === 'wheat').length;
          const millets = this.bundleContents.filter(i => i.category === 'millet').length;
          const besan = this.bundleContents.filter(i => i.category === 'besan').length;
          
          if (category === 'wheat' && wheats >= 1) return false;
          if (category === 'millet' && millets >= 1) return false;
          if (category === 'besan' && besan >= 1) return false;
      }
      else if (this.comboHandle === 'the-pasta-pantry-power-pack') {
          if (this.bundleContents.length > 0) {
              const firstItem = this.bundleContents[0];
              const firstItemTitle = firstItem.product_title ? firstItem.product_title.toLowerCase() : '';
              const firstItemCat = firstItem.category ? firstItem.category.toLowerCase() : '';
              const firstIsMillet = firstItemTitle.includes('millet') || firstItemCat.includes('millet');
              
              const optionIsMillet = title.includes('millet') || category.includes('millet');
              
              if (firstIsMillet && !optionIsMillet) return false;
              if (!firstIsMillet && optionIsMillet) return false;
          }
      }
      else if (this.comboHandle === 'complete-honest-kitchen-box') {
          const wheats = this.bundleContents.filter(i => i.category === 'wheat').length;
          const besan = this.bundleContents.filter(i => i.category === 'besan').length;
          
          const pastas = this.bundleContents.filter(i => i.category === 'pasta' && !(i.product_title || '').toLowerCase().includes('vermicelli')).length;
          const millets = this.bundleContents.filter(i => i.category === 'millet' && !(i.product_title || '').toLowerCase().includes('vermicelli')).length;
          const vermicelli = this.bundleContents.filter(i => i.category === 'vermicelli' || (i.product_title || '').toLowerCase().includes('vermicelli')).length;

          const isOptionVermicelli = category === 'vermicelli' || title.includes('vermicelli');
          
          if (category === 'wheat' && wheats >= 1) return false;
          if (category === 'besan' && besan >= 1) return false;
          
          if (isOptionVermicelli) {
              if (vermicelli >= 1) return false;
          } else {
              if (category === 'pasta' && pastas >= 4) return false;
              if (category === 'millet' && millets >= 4) return false; // 2 required + 2 optional
          }
      }
      return true;
  }

  isBundleComplete() {
      if (this.comboHandle === 'build-your-honest-food-discovery-box') {
          const pastas = this.bundleContents.filter(i => i.category === 'pasta').length;
          const millets = this.bundleContents.filter(i => i.category === 'millet').length;
          const wheats = this.bundleContents.filter(i => i.category === 'wheat').length;
          return pastas === 4 && millets === 1 && wheats === 1;
      }
      else if (this.comboHandle === 'the-pasta-pantry-power-pack') {
          return this.bundleContents.length === 4;
      }
      else if (this.comboHandle === 'everyday-roti-ritual-box') {
          const wheats = this.bundleContents.filter(i => i.category === 'wheat').length;
          const millets = this.bundleContents.filter(i => i.category === 'millet').length;
          const besan = this.bundleContents.filter(i => i.category === 'besan').length;
          return wheats === 1 && millets === 1 && besan === 1;
      }
      else if (this.comboHandle === 'complete-honest-kitchen-box') {
          const wheats = this.bundleContents.filter(i => i.category === 'wheat').length; 
          const besan = this.bundleContents.filter(i => i.category === 'besan').length;
          const pastas = this.bundleContents.filter(i => i.category === 'pasta' && !(i.product_title || '').toLowerCase().includes('vermicelli')).length; 
          const millets = this.bundleContents.filter(i => i.category === 'millet' && !(i.product_title || '').toLowerCase().includes('vermicelli'));
          const uniqueMillets = new Set(millets.map(m => m.product_id)).size;
          return wheats === 1 && besan === 1 && pastas === 4 && uniqueMillets >= 2;
      }
      return this.bundleContents.length > 0;
  }

  removeFromBundle(btn) {
    const uid = btn.dataset.uid;
    if(!uid) return;

    const itemToRemove = this.bundleContents.find(item => String(item.uid) === String(uid));
    
    // Prevent removal of auto-added items
    if (this.comboHandle === 'everyday-roti-ritual-box' && itemToRemove && itemToRemove.category === 'besan') {
        return;
    }
    if (this.comboHandle === 'complete-honest-kitchen-box' && itemToRemove) {
        if (itemToRemove.category === 'besan' || itemToRemove.category === 'wheat') {
             return;
        }
    }

    this.bundleContents = this.bundleContents.filter(item => String(item.uid) !== String(uid));

    this.sortBundle();

    localStorage.setItem(this.storageKey, JSON.stringify(this.bundleContents));

    this.buildBundle();
    this.calcPrices();
  }

  sortBundle() {
    const order = {
      'pasta': 1,
      'millet': 2,
      'wheat': 3,
      'khapli': 4,
      'besan': 5
    };
    
    this.bundleContents.sort((a, b) => {
      const orderA = order[a.category] || 99;
      const orderB = order[b.category] || 99;
      return orderA - orderB;
    });
  }

  buildBundle() {
    let unplacedItems = [...this.bundleContents];
    const wrappers = this.querySelectorAll(".collection-bundle-card-list-wrapper");
    const wrappersData = [];
    
    wrappers.forEach(wrapper => {
        const titleText = (wrapper.querySelector("h3.title")?.textContent || '').toLowerCase();
        let cats = [];
        if (titleText.includes('pasta')) cats.push('pasta');
        if (titleText.includes('millet')) cats.push('millet');
        if (titleText.includes('wheat')) cats.push('wheat');
        if (titleText.includes('besan')) cats.push('besan');
        if (titleText.includes('khapli')) cats.push('khapli');
        if (titleText.includes('vermicelli') || titleText.includes('add on') || titleText.includes('addon')) cats.push('vermicelli');
        
        wrappersData.push({
           wrapper,
           cats,
           lis: wrapper.querySelectorAll("li"),
           assignedItems: []
        });
    });

    // First pass: place items in wrappers that have specific category matches
    wrappersData.forEach(data => {
        if (data.cats.length > 0) {
            let itemsForThisWrapper = [];
            for (let i = unplacedItems.length - 1; i >= 0; i--) {
                const item = unplacedItems[i];
                const isItemVermicelli = item.category === 'vermicelli' || (item.product_title || '').toLowerCase().includes('vermicelli');
                
                let matches = false;
                if (data.cats.includes('vermicelli') && isItemVermicelli) matches = true;
                else if (!isItemVermicelli && data.cats.includes(item.category)) matches = true;
                
                if (matches) {
                    itemsForThisWrapper.push(item);
                    unplacedItems.splice(i, 1);
                }
            }
            itemsForThisWrapper.reverse();
            data.assignedItems = itemsForThisWrapper;
        }
    });

    // Second pass: place remaining unplaced items in wrappers that have empty slots
    wrappersData.forEach(data => {
        const slots = data.lis.length;
        while (data.assignedItems.length < slots && unplacedItems.length > 0) {
            data.assignedItems.push(unplacedItems.shift());
        }
    });

    wrappersData.forEach(data => {
        data.lis.forEach((elem, index) => {
            const bundleElem = data.assignedItems[index];
            const img = elem.querySelector("img");
            const btn = elem.querySelector(".btn-close");
            const numberSpan = elem.querySelector("span[data-number]");
            const number = numberSpan ? numberSpan.dataset.number : index + 1;

            if (bundleElem) {
              elem.classList.add("active");
              img.setAttribute("src", bundleElem.variant_img);
              img.setAttribute("alt", bundleElem.product_title);
              img.setAttribute("title", bundleElem.product_title);
              img.setAttribute("data-bs-title", bundleElem.product_title);

              if (typeof bootstrap !== 'undefined' && bootstrap.Tooltip) {
                  const t = bootstrap.Tooltip.getInstance(img);
                  if (t) t.dispose();
                  new bootstrap.Tooltip(img, { title: bundleElem.product_title });
              }

              btn.setAttribute("data-variant-id", bundleElem.variant_id);
              btn.setAttribute("data-uid", bundleElem.uid);
              if (bundleElem.auto_added) {
                  btn.style.display = 'none';
              } else {
                  btn.style.display = 'block';
              }

              if (numberSpan) {
                  let cat = (bundleElem.category || '').toLowerCase();
                  let title = (bundleElem.product_title || '').toLowerCase();
                  let displayLabel = '';
                  
                  if (title.includes('vermicelli') || cat === 'vermicelli') displayLabel = 'Vermicelli';
                  else if (cat === 'pasta') displayLabel = 'Semolina Pasta';
                  else if (cat === 'wheat') displayLabel = 'Wheat Flour';
                  else if (cat === 'besan') displayLabel = 'Besan';
                  else if (cat === 'millet') {
                      if (title.includes('pasta')) displayLabel = 'Millet Pasta';
                      else displayLabel = 'Millet Flour';
                  } else {
                      displayLabel = cat ? (cat.charAt(0).toUpperCase() + cat.slice(1)) : '';
                  }
                  
                  numberSpan.textContent = `${number} ${displayLabel}`;
              }
            } else {
              elem.classList.remove("active");
              img.setAttribute("src", img.dataset.src);
              img.setAttribute("alt", "");
              img.removeAttribute("title");
              img.removeAttribute("data-bs-title");

              if (typeof bootstrap !== 'undefined' && bootstrap.Tooltip) {
                  const t = bootstrap.Tooltip.getInstance(img);
                  if (t) t.dispose();
              }

              btn.removeAttribute("data-variant-id");
              btn.removeAttribute("data-uid");
              btn.style.display = 'block';
              
              if (numberSpan) {
                  numberSpan.textContent = number;
              }
            }
        });
    });

    // Sync Checkboxes
    this.querySelectorAll(".combo-checkbox").forEach((checkbox) => {
        const productId = Number(checkbox.dataset.productId);
        const exists = this.bundleContents.find(i => i.product_id === productId);
        checkbox.checked = !!exists;
        checkbox.disabled = false;
        
        const label = checkbox.nextElementSibling;
        if(label && checkbox.dataset.originalText === undefined) {
            checkbox.dataset.originalText = label.textContent.trim();
        }
        if(label) {
            if(checkbox.checked) {
                if (exists && exists.auto_added) {
                    label.textContent = `✓ ${exists.product_title || 'Item'} (included)`;
                    checkbox.disabled = true;
                } else {
                    label.textContent = "Added to Bundle";
                }
            } else {
                label.textContent = checkbox.dataset.originalText;
            }
        }
    });

    // Disable checkboxes for categories that are full
    this.querySelectorAll(".product-card-form").forEach((form) => {
        const select = form.querySelector("select");
        const checkbox = form.querySelector(".combo-checkbox");
        if (select && checkbox && !checkbox.checked) {
            const selectedOption = select.options[select.selectedIndex];
            if (selectedOption) {
                const category = selectedOption.dataset.comboCategory ? selectedOption.dataset.comboCategory.toLowerCase() : '';
                const title = selectedOption.dataset.productTitle ? selectedOption.dataset.productTitle.toLowerCase() : '';
                
                if (!this.canAddItemCategory(category, title)) {
                    checkbox.disabled = true;
                }
                
                // For kitchen box, prevent duplicate millet
                if (this.comboHandle === 'complete-honest-kitchen-box' && category === 'millet') {
                    const productId = Number(selectedOption.dataset.productId);
                    if (this.bundleContents.find(i => i.product_id === productId)) {
                         checkbox.disabled = true;
                    }
                }
            }
        }
    });

    this.updateGridVisibility();

    const isComplete = this.isBundleComplete();
    this.querySelectorAll(".btn-bundle-checkout").forEach((btn) => {
      btn.disabled = !isComplete;
      
      if (this.comboHandle === 'complete-honest-kitchen-box') {
          const wheats = this.bundleContents.filter(i => i.category === 'wheat').length; 
          const besan = this.bundleContents.filter(i => i.category === 'besan').length;
          const pastas = this.bundleContents.filter(i => i.category === 'pasta' && !(i.product_title || '').toLowerCase().includes('vermicelli')).length; 
          const millets = this.bundleContents.filter(i => i.category === 'millet' && !(i.product_title || '').toLowerCase().includes('vermicelli'));
          const uniqueMillets = new Set(millets.map(m => m.product_id)).size;
          
          if (!isComplete) {
              // btn.textContent = `Need: ${pastas}/4 Pastas, ${uniqueMillets}/2 Millets, ${wheats}/1 Wheat, ${besan}/1 Besan`;
              btn.textContent = 'ADD TO CART';
          } else {
              btn.textContent = 'ADD TO CART';
          }
      } else {
          if (btn.dataset.redirectToCheckout === "true") {
              btn.textContent = 'Checkout';
          } else {
              btn.textContent = 'Add to Cart';
          }
      }
    });
  }

  updateGridVisibility() {
      const stepCombos = ['build-your-honest-food-discovery-box', 'everyday-roti-ritual-box', 'complete-honest-kitchen-box'];
      if (!stepCombos.includes(this.comboHandle)) return;

      const pastas = this.bundleContents.filter(i => i.category === 'pasta' && !(i.product_title || '').toLowerCase().includes('vermicelli')).length;
      const millets = this.bundleContents.filter(i => i.category === 'millet' && !(i.product_title || '').toLowerCase().includes('vermicelli')).length;
      const wheats = this.bundleContents.filter(i => i.category === 'wheat').length;
      
      let activeCategory = '';

      if (this.comboHandle === 'build-your-honest-food-discovery-box') {
          if (pastas < 4) activeCategory = 'pasta';
          else if (millets < 1) activeCategory = 'millet';
          else if (wheats < 1) activeCategory = 'wheat';
          else activeCategory = 'all';
      } else if (this.comboHandle === 'everyday-roti-ritual-box') {
          if (wheats < 1) activeCategory = 'wheat';
          else if (millets < 1) activeCategory = 'millet';
          else activeCategory = 'all';
      } else if (this.comboHandle === 'complete-honest-kitchen-box') {
          if (pastas < 4) activeCategory = 'pasta';
          else if (millets < 2) activeCategory = 'millet';
          else activeCategory = 'all';
      }

      this.querySelectorAll(".product-card").forEach(card => {
          const select = card.querySelector("select");
          if (!select) return;
          const option = select.options[select.selectedIndex];
          if (!option) return;
          const category = (option.dataset.comboCategory || '').toLowerCase();
          const title = (option.dataset.productTitle || '').toLowerCase();
          let isItemVermicelli = category === 'vermicelli' || title.includes('vermicelli');
          
          let displayCategory = category;
          if (isItemVermicelli) displayCategory = 'vermicelli';
          
          const container = card.closest("div[role='listitem']");
          if (!container) return;

          // Always show auto_added items so user knows they are there
          const isAutoAdded = this.bundleContents.find(i => i.product_id === Number(option.dataset.productId))?.auto_added;
          if (isAutoAdded) {
              container.style.display = 'block';
              return;
          }
          
          if (activeCategory === 'all') {
              container.style.display = 'block';
          } else {
              if (displayCategory === activeCategory) {
                  container.style.display = 'block';
              } else {
                  container.style.display = 'none';
              }
          }
      });
  }

  calcPrices() {
    const totalPrice = this.bundleContents.reduce(
      (accumulator, currentValue) => currentValue.variant_price + accumulator,
      0
    );

    const totalMRP = this.bundleContents.reduce(
      (accumulator, currentValue) => (currentValue.variant_compare_at_price || currentValue.variant_price) + accumulator,
      0
    );

    let applicableDiscount = 0;
    const currentQty = this.bundleContents.length;
    
    this.tiers.forEach(tier => {
      if (currentQty >= tier.qty) {
        if (tier.discount > applicableDiscount) {
            applicableDiscount = tier.discount;
        }
      }
    });

    const discountMultiplier = (100 - applicableDiscount) / 100;
    
    let bundlePrice = totalPrice;
    
    if (applicableDiscount > 0) {
        bundlePrice = Math.round(totalPrice * discountMultiplier); 
    } else {
        bundlePrice = totalMRP;
    }
    
    const savings = totalMRP - bundlePrice;
    const savingsPercent = totalMRP > 0 ? ((savings / totalMRP) * 100).toFixed(1) : "0.0";

    this.querySelectorAll("[data-bundle-price]").forEach((elem) => {
      if(window.Shopify && window.Shopify.formatMoney) {
          elem.textContent = window.Shopify.formatMoney(bundlePrice);
      } else {
          elem.textContent = '₹' + (bundlePrice / 100).toFixed(2);
      }
    });

    this.querySelectorAll("[data-combined-mrp]").forEach((elem) => {
      if(window.Shopify && window.Shopify.formatMoney) {
          elem.textContent = window.Shopify.formatMoney(totalMRP);
      } else {
          elem.textContent = '₹' + (totalMRP / 100).toFixed(2);
      }
    });

    this.querySelectorAll("[data-you-save]").forEach((elem) => {
      if(window.Shopify && window.Shopify.formatMoney) {
          elem.textContent = window.Shopify.formatMoney(savings);
      } else {
          elem.textContent = '₹' + (savings / 100).toFixed(2);
      }
    });

    this.querySelectorAll("[data-you-save-percent]").forEach((elem) => {
      elem.textContent = savingsPercent;
    });
  }

  handleCartStickyPosition() {
    if (window.matchMedia("(min-width: 800px)").matches) {
      const headerGroup = document.querySelector("#header-group.sticky-top");
      let oldScroll = window.scrollY;

      window.addEventListener("scroll", () => {
        const newScroll = window.scrollY;
        if (newScroll > oldScroll) {
          if (headerGroup && newScroll > headerGroup.clientHeight) {
            this.card.style.top = "20px";
          }
        } else if (newScroll < oldScroll) {
          if(headerGroup) {
              this.card.style.top = `${headerGroup.clientHeight + 20}px`;
          }
        }
        oldScroll = Math.max(window.scrollY, 0);
      });
    }
  }

  onChangeProductCardVariant(select) {
    const variantImg = select[select.selectedIndex].dataset.variantImg;
    if (variantImg && variantImg.length) {
      const imgElem = select.closest(".product-card").querySelector(".product-card-img-wrapper img");
      if(imgElem) imgElem.setAttribute("src", variantImg);
    }
    this.buildBundle(); 
  }

  animateBtnBundleCheckout() {
    const animate = () => {
      this.querySelectorAll(".btn-bundle-checkout").forEach((btn) => {
        if (!btn.disabled) {
            btn.classList.add("animate__animated", "animate__shakeX");
        }
      });
      setTimeout(() => {
        this.querySelectorAll(".btn-bundle-checkout").forEach((btn) => {
          btn.classList.remove("animate__animated", "animate__shakeX");
        });
      }, 1000);
    };
    animate();

    setTimeout(() => {
      setInterval(() => {
        animate();
      }, 4000);
    }, 1000);
  }

  async handleCheckout(btn) {
    btn.classList.add("loading");
    btn.disabled = true;
    btn.setAttribute("aria-busy", "true");

    const items = [];
    this.bundleContents.forEach((elem) => {
      items.push({
        id: elem.variant_id,
        quantity: 1,
      });
    });

    if (btn.dataset.redirectToCheckout === "true") {
      await fetch(window.Shopify.routes.cart_add_url + '.js', {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      });
      window.location.href = window.Shopify.routes.root_url + 'checkout';
    } else {
      const cartContainer = document.querySelector("cart-container");
      if(cartContainer) {
          await cartContainer.add({ items });
      } else {
          // Fallback if cart-container doesn't exist
          await fetch(window.Shopify.routes.cart_add_url + '.js', {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items }),
          });
          window.location.href = window.Shopify.routes.cart_url;
      }
    }

    btn.classList.remove("loading");
    btn.disabled = false;
    btn.setAttribute("aria-busy", "false");

    this.bundleContents = [];
    localStorage.setItem(this.storageKey, JSON.stringify(this.bundleContents));
    this.buildBundle();
    this.calcPrices();
  }

  initStickyMobileCard() {
    const stickyCard = this.querySelector("#collection-bundle-sticky-mobile-card");
    if (!stickyCard) return;

    const cardElem = document.querySelector("#collection-bundle-card");
    if(!cardElem) return;

    const top = cardElem.getBoundingClientRect().bottom;

    window.addEventListener("scroll", () => {
      if (window.matchMedia("(min-width: 800px)").matches) return;

      if (window.scrollY > top) {
        stickyCard.classList.add("show");
        document.body.style.paddingBottom = stickyCard.clientHeight + "px";
      } else {
        stickyCard.classList.remove("show");
        document.body.style.paddingBottom = 0;
      }
    });

    const btnScrollBundleCard = stickyCard.querySelector(".btn-scroll-bundle-card");
    const headerGroup = document.querySelector("#header-group.sticky-top");
    const headerHeight = headerGroup ? headerGroup.clientHeight : 0;

    btnScrollBundleCard?.addEventListener("click", (e) => {
      window.scrollTo({
        behavior: "smooth",
        top: cardElem.getBoundingClientRect().top - document.body.getBoundingClientRect().top - headerHeight - 16,
      });
    });
  }
}
customElements.define("bundle-builder", CustomComboBuilder);
